import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./styles/member.scss";
import { motion } from "framer-motion";
import { backend } from '../../../src/components/apipath';
import axios from "axios";
import Swal from "sweetalert2";
import {  Navigate } from "react-router-dom";

function Consult() {
    const auth = JSON.parse(localStorage.getItem('auth'));
    useEffect(() => {
        const fetchMyQas = async () => {
            try {
                const response = await axios.get(`${backend}qa/my-qa/${auth.mem_id}`);
                setMyQas(response.data);
            } catch (err) {
                console.error('無法取得會員自己的 Q&A:', err);
            }
        };

        if (auth?.mem_id) fetchMyQas();
    }, [auth?.mem_id]);
    const [currentStep, setCurrentStep] = useState(0);
    const [formData, setFormData] = useState({
        subject: '',
        questiontype: '',
        keyword: '',
        questionnum: '',
    });
    const [myQas, setMyQas] = useState([]);
    const [formErrors, setFormErrors] = useState({});
    const [qaData, setQaData] = useState([]);
    const [isKeywordSearch, setIsKeywordSearch] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    

    useEffect(() => {
        if (formData.subject && formData.questiontype && formData.questionnum.trim()) {
            fetchQaData({
                subject: formData.subject,
                questiontype: formData.questiontype,
                questionnum: formData.questionnum.trim(),
            });
        }
    }, [formData.subject, formData.questiontype, formData.questionnum]);

    if (!auth || !auth.token) {
        Swal.fire({
            icon: "warning",
            color: "#224040",
            text: "尚未登入會員",
        });
        // 如果沒有登入，跳轉到登入頁面
        return <Navigate to="/member/memberlogin" replace />;
    }
   

   

    const getMemberData = () => {
        try {
            const authData = JSON.parse(localStorage.getItem('auth'));
            return authData ? authData : {};
        } catch (error) {
            console.error('無法解析 auth 資料:', error);
            return {};
        }
    };

    const fetchQaData = async (keywordOrParams) => {
        try {
            let response;
            if (typeof keywordOrParams === 'string') {
                setIsKeywordSearch(true); // 標記為關鍵字搜尋
                response = await axios.get(`${backend}qa/cpadata/${keywordOrParams}`);
            } else {
                const { subject, questiontype, questionnum } = keywordOrParams;
                response = await axios.get(`${backend}qa/cpadata/${subject}/${questiontype}/${questionnum}`);
            }

            const result = Array.isArray(response.data) ? response.data : [];
            setQaData(result);
        } catch (error) {
            console.error('Error fetching QA data:', error);
            setQaData([]);
        }
    };

    

    const validateStep1 = () => {
        const errors = {};

        if (formData.keyword.trim()) {
            fetchQaData(formData.keyword.trim());
            setFormErrors({});
            return true;
        }

        if (!formData.subject.trim()) {
            errors.subject = '請選擇題目';
        }
        if (!formData.questiontype.trim()) {
            errors.questiontype = '請選擇題型';
        }
        if (!formData.questionnum.trim() || !/^\d{5}$/.test(formData.questionnum.trim())) {
            errors.questionnum = '題號必須是五位數字';
        }

        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleNext = () => {
        if (currentStep === 0 && validateStep1()) {
            setCurrentStep(1);
        }
    };

    const handlePrevious = () => {
        setCurrentStep(0);
        setIsKeywordSearch(false); // 重置關鍵字搜尋狀態
    };

    const handleQuestionSubmit = async (e) => {
        e.preventDefault();
    
        // 獲取會員資料
        const memberData = getMemberData();
        const mem_id = memberData.mem_id || null;
    
        if (!mem_id) {
            Swal.fire({
                icon: 'error',
                title: '提交失敗',
                text: '無法獲取會員信息，請重新登入。',
            });
            return;
        }
    
        const saveData = {
            subject: formData.subject || '未填寫',
            questiontype: formData.questiontype || '未填寫',
            cpa: formData.questionnum || '未填寫',
            my_question: document.getElementById('qtextarea').value || '未填寫',
            my_answer: document.getElementById('atextarea').value || '未填寫',
            mem_id: mem_id, // 添加會員 ID
        };
    
        try {
    
            const response = await axios.post(`${backend}qa/save-question`, saveData);
            // const { questionId, teacherId, teacherEmail } = response.data;
    
            Swal.fire({
                icon: 'success',
                title: '發問成功',
                text: `您的問題已提交並通知老師！`,
            });
        } catch (error) {
            console.error('操作失敗:', error);
    
            Swal.fire({
                icon: 'error',
                title: '提交失敗',
                text: '請稍後再試！',
            });
        }
    };
    return (
        <>
            <section className="multi_step_form pb-5">
                <form id="msform">
                    {/* 第一步 */}
                    {currentStep === 0 && (
                        <motion.fieldset
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.8 }}
                        >
                            <div className="title">
                                <h2>搜尋知識庫</h2>
                                <p>可於歷史紀錄中搜尋題號、問答相關文字</p>
                            </div>
                            <div className="form-row just">
                                <div className="form-group col-md-8 m-auto">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="填寫關鍵字或題號"
                                        name="keyword"
                                        value={formData.keyword}
                                        onChange={handleChange}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault(); 
                                                handleNext();
                                            }
                                        }}
                                    />
                                </div>
                                <div className="dropdown col-md-8 m-auto">
                                    <select
                                        className="form-select mt-4"
                                        name="subject"
                                        value={formData.subject}
                                        onChange={handleChange}
                                    >
                                        <option value="" disabled>請選擇題目</option>
                                        {['far', 'aud', 'reg', 'bar', 'isc', 'tcp'].map((sub) => (
                                            <option key={sub} value={sub}>
                                                {sub.toUpperCase()}
                                            </option>
                                        ))}
                                    </select>
                                    {formErrors.subject && <div className="text-danger">{formErrors.subject}</div>}
                                    {formData.subject && (
                                        <select
                                            className="form-select mt-4"
                                            name="questiontype"
                                            value={formData.questiontype}
                                            onChange={handleChange}
                                        >
                                            <option value="" disabled>請選擇題型</option>
                                            {['mcq', 'sim', 'moc'].map((type) => (
                                                <option key={type} value={type}>
                                                    {type.toUpperCase()}
                                                </option>
                                            ))}
                                        </select>
                                    )}
                                    {formErrors.questiontype && <div className="text-danger">{formErrors.questiontype}</div>}
                                    {formData.questiontype && (
                                        <input
                                            className="form-control mt-4"
                                            type="text"
                                            name="questionnum"
                                            placeholder="請輸入5位數題號"
                                            value={formData.questionnum}
                                            onChange={handleChange}
                                        />
                                    )}
                                    {formErrors.questionnum && <div className="text-danger">{formErrors.questionnum}</div>}
                                </div>
                            </div>
                            <div className="action-buttons mt-5 m-auto">
                                <Link to="/">
                                    <button type="button" className="action-button previous_button">取消</button>
                                </Link>
                                <button type="button" className="action-button" onClick={handleNext}>下一步</button>
                            </div>
                        </motion.fieldset>
                    )}

                    {/* 第二步 */}
                    {currentStep === 1 && (
                        <motion.fieldset
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.8 }}
                        >
                            <div className="title">
                                <h2>Q&A</h2>
                                <p>歷史紀錄</p>
                            </div>
                                {qaData.map((qa) => (
                                <div className="form-group border border-secondary p-2 mb-5">
                                    <div key={qa.qa_id} className="mb-5">
                                        <div className="text-left d-inline">
                                            <strong>科目:</strong> {qa.subject}
                                        </div>
                                        <div className="text-left d-inline">
                                            <strong>題型:</strong> {qa.xtype}
                                        </div>
                                        <div className="text-left d-inline">
                                            <strong>題號:</strong> CPA-{qa.cpa}
                                        </div>
                                        <div className="mt-5">
                                            <strong>問題:</strong>
                                            <p dangerouslySetInnerHTML={{ __html: qa.my_question }}></p>
                                        </div>
                                        <div className="mt-5">
                                            <strong>回答:</strong>
                                            <p dangerouslySetInnerHTML={{ __html: qa.reply }}></p>
                                        </div>
                                    </div>
                                </div>
                                ))}
                            
                            {!isKeywordSearch && (
                                <div className="form-group border border-secondary p-2 mb-5">
                                    <h5>發問</h5>
                                    <textarea className="form-control" id="qtextarea" rows="3" placeholder="請輸入問題"></textarea>
                                    <textarea className="form-control mt-4" id="atextarea" rows="3" placeholder="請輸入答案"></textarea>
                                    <button className="action-button mt-4" onClick={handleQuestionSubmit}>送出</button>
                                </div>
                            )}
                            <div className="action-buttons mt-5 m-auto mb-5">
                                <button type="button" className="action-button previous_button" onClick={handlePrevious}>上一步</button>
                            </div>
                        </motion.fieldset>
                    )}
                </form>
            </section>
            <section className="multi_step_form pt-5">
                <div className="form-group border border-secondary p-2 mb-5 container">
                    <h5 className="mb-3">問題紀錄</h5>
                    {myQas.length === 0 ? (
                        <p>尚未有發問紀錄。</p>
                    ) : (
                        myQas.map((qa) => (
                            <div key={qa.qa_id} className="mb-4 p-3 border rounded bg-light">
                                <div><strong>科目:</strong> {qa.subject}</div>
                                <div><strong>題型:</strong> {qa.xtype}</div>
                                <div><strong>題號:</strong> CPA-{qa.cpa}</div>
                                <div className="mt-3"><strong>我問:</strong> <div dangerouslySetInnerHTML={{ __html: qa.my_question }} /></div>
                                <div className="mt-3"><strong>我的答案:</strong> <div dangerouslySetInnerHTML={{ __html: qa.my_answer }} /></div>
                                <div className="mt-3"><strong>老師回覆:</strong> <div dangerouslySetInnerHTML={{ __html: qa.reply }} /></div>
                            </div>
                        ))
                    )}
                </div>
            </section>
        </>
    );
}

export default Consult;
